import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=31c84546&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
import style0 from "./Profile.vue?vue&type=style&index=0&id=31c84546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c84546",
  null
  
)

export default component.exports